import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectServicedeskRoute: InvariantJiraRoute = {
	name: 'servicedesk-issues',
	path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?',
};
